<template>
  <v-card flat rounded="lg" class="mt-4">
    <v-card-text>
      <v-progress-circular
        indeterminate
        v-if="carregando"
      ></v-progress-circular>
      <template v-else>
        <v-card flat>
          <v-card-title class="font-weight-bold"
            >Para receber o código de acesso desta funcionalidade, selecione uma
            das opções abaixo:</v-card-title
          >
          <v-card-text>
            <v-radio-group hide-details="" v-model="enviarCodigoViaModel">
              <v-radio
                v-for="(op, i) in opcoesEnviar"
                :key="i"
                :label="op"
                :value="op"
                class="pb-2"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
        <v-card flat>
          <v-card-title class="font-weight-bold"
            >Enviar código para:</v-card-title
          >
          <v-card-text>
            <v-alert
              type="info"
              text
              v-if="dadosCadastrais.numeros_telefone.length == 0"
              >Nenhum telefone encontrado. Atualize seu número!</v-alert
            >

            <v-row v-else>
              <v-col xl="auto" lg="auto" md="auto" cols="12" align-self="center">
                <v-select
                  label="Telefone"
                  no-data-text="Nenhum telefone encontrado - Atualize seu contato"
                  :items="dadosCadastrais.numeros_telefone"
                  item-value="numero_completo"
                  item-text="numero_oculto"
                  v-model="telefoneModel"     
                  :hide-details="isMobile()"             
                ></v-select>
              </v-col>
              <v-col xl="auto" lg="auto" md="auto" cols="12" align-self="center">
                <v-btn
                  color="info"
                  class="font-weight-bold"
                  to="/atualizacao-cadastral/contato"
                  rounded
                  block
                  text                  
                >
                  Atualizar meu número
                </v-btn>
              </v-col>
            </v-row>

            <template v-if="dadosCadastrais.numeros_telefone.length > 0">
              <v-row dense class="mt-3">
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-btn
                    color="success"
                    rounded
                    :block="isMobile()"
                    @click="enviarCodigoSeguranca()"
                    class="font-weight-bold"
                    :loading="enviandoCodigo"
                    >Enviar código</v-btn
                  >
                </v-col>
                <v-col xl="auto" lg="auto" md="auto" cols="12">
                  <v-btn
                    v-if="codigoEnviado"
                    outlined
                    :block="isMobile()"
                    rounded
                    @click="setStep(step + 1)"
                    >Já recebi o código</v-btn
                  >
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("atualizacaoCadastral", ["dadosCadastrais"]),
    ...mapState("configComprasPrazo", [
      "enviarCodigoVia",
      "telefoneSelecionado",
      "codigoEnviado",
      "step",
      "enviandoCodigo",
    ]),
    enviarCodigoViaModel: {
      get: function () {
        return this.enviarCodigoVia;
      },
      set: function (value) {
        this.setEnviarCodigoVia(value);
      },
    },
    telefoneModel: {
      get: function () {
        return this.telefoneSelecionado;
      },
      set: function (value) {
        this.setTelefone(value);
      },
    },
  },
  data: () => ({
    opcoesEnviar: ["Whatsapp", "Sms"],
    carregando: true,
    opcaoSelec: "Whatsapp",
  }),
  methods: {
    ...mapActions("atualizacaoCadastral", ["getDadosCadastrais"]),
    ...mapActions("configComprasPrazo", ["enviarCodigoSeguranca"]),
    ...mapMutations("configComprasPrazo", [
      "setEnviarCodigoVia",
      "setTelefone",
      "setStep",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.carregando = true;
    this.setTelefone("");
    await this.getDadosCadastrais();
    //this.dadosCadastrais.numeros_telefone = [];
    if (this.dadosCadastrais.numeros_telefone.length > 0)
      this.setTelefone(
        this.dadosCadastrais.numeros_telefone[0].numero_completo
      );
    this.carregando = false;
  },
};
</script>

<style>
</style>